import { InjectionToken } from '@angular/core';

export const WINDOW = new InjectionToken<Window>('window');

export const RouteFragment = {
  Admin: 'admin',
  CompanyDocuments: 'company-documents',
  DataAnalytics: 'data-analytics',
  Finance: 'finance',
  FinanceManagement: 'finance-management',
  Hr: 'hr',
  Legal: 'legal',
  Main: 'main',
  NoRole: 'norole',
  OperationsServices: 'operations-services',
  Organization: 'org',
  Overview: 'overview',
  Roles: 'roles',
  SignIn: 'signin',
  StrategyBoard: 'strategy-board',
} as const;

export const RouteParam = {
  OrganizationTenantKey: 'orgTenantKey',
} as const;
